import React from "react";
import { connect, ConnectedProps } from 'react-redux';
import { Button, Grid, Header, Image } from "semantic-ui-react";
import * as Core from '../../core';
import { ApplicationState } from '../..';
import userManager from '../userManager';

const connector = connect(
    (state: ApplicationState) => state.core,
    Core.actions
)
type PropsFromRedux = ConnectedProps<typeof connector>

export type PrincipaleProps = PropsFromRedux

class Principale extends React.Component<PrincipaleProps> {

    componentDidMount() {
        this.props.loadTenant();
    }

    render() {
        let tenantImage = '';
        if (this.props.tenant !== undefined) {
            document.title = "Portale " + this.props.tenant.ragioneSociale;
            const favicon = document.getElementById("favicon") as any;
            favicon.href = this.props.tenant.imageSmall;

            tenantImage = this.props.tenant.image;
        }
        
        return (
            <Grid centered={true} style={{ marginTop: 100 }}>
                <Grid.Row />
                <Grid.Row>
                    <Image src={tenantImage} centered={true} style={{ maxHeight: '150px' }} />
                </Grid.Row>
                <Grid.Row>
                    <Header as="h1" textAlign="center">
                        Benvenuto nell'area riservata
                        <Header.Subheader>Per utilizzare il servizio effettua il login.</Header.Subheader>
                    </Header>
                </Grid.Row>
                <Grid.Row />
                <Grid.Row>
                    <Button color="blue" onClick={this.loginClick}>Esegui il login</Button>
                </Grid.Row>
            </Grid>
        );
    }

    loginClick = () => {
        var args = {
            useReplaceToNavigate: true // sovrascrive la history: https://github.com/IdentityModel/oidc-client-js/issues/896
        };

        userManager.signinRedirect(args);
    }
}

export default connector(Principale as any);
